const HOME_ROUTE_NAMES = ['client-home', 'courier-home', 'restaurant-home', 'admin-orders']

export function routeNeedsBack(route) {
  if (route.meta.showBack === false) return false
  if (route.meta.showBack === true) return true
  return !HOME_ROUTE_NAMES.includes(route.name)
}
